module.exports = __webpack_public_path__ + "lang/en.json";


//////////////////
// WEBPACK FOOTER
// ./lang/en.json
// module id = 79
// module chunks = d-game